export default [
  // {
  //   name: "hoodie",
  //   path: "/models/hoodie.gltf",
  //   type: "gltfModel",
  // },
  // {
  //   name: "damagedHelmet",
  //   path: "/models/DamagedHelmet.gltf",
  //   type: "gltfModel",
  // },
];
